module.exports = __webpack_public_path__ + "static/securityIcon-0428bc8e0b354d074094b2e5d4da0438.png";